"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _InputWrapper = require("./InputWrapper");

var _InputWrapper2 = _interopRequireDefault(_InputWrapper);

require("./_inputWrapper.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _InputWrapper2.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cx/ui/internal/InputWrapper/index.js
// module id = 234
// module chunks = 0